import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom'
import { clearCartItem, decreaseQuantity, increaseQuantity, removeCartItem } from "../Redux/features/Cart/CartSlice"
import { formatSlug } from '../Utils/Helper';

const AddToCart = () => {
    const dispatch = useDispatch()
    const cartList = useSelector((state) => state.Cart)
    const [subTotalAmount, setSubTotalAmount] = useState(0)

    const cartItems = useSelector(state => state.Cart)

    const calculatesubTotalAmount = () => {
        const subTotal = cartList.reduce((acc, cur) => acc + cur.quantity * cur.product_variant_sale_price, 0)
        setSubTotalAmount(subTotal)
    }

    const Countdown = ({ expiresAt, product_variant_id }) => {
        const [timeLeft, setTimeLeft] = useState(getTimeLeft());

        function getTimeLeft() {
            const now = Date.now();
            const timeDifference = expiresAt - now;

            if (timeDifference <= 0) {
                return {
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                    finished: true
                };
            }

            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            return {
                days,
                hours,
                minutes,
                seconds,
                finished: false
            };
        }

        function formatTimeUnit(value) {
            return value.toString().padStart(2, '0');
        }

        useEffect(() => {
            const interval = setInterval(() => {
                setTimeLeft(getTimeLeft());
            }, 1000);

            return () => clearInterval(interval);
        }, []);

        if (timeLeft.finished) {
            dispatch(removeCartItem(product_variant_id))
            return (
                <div>
                    Expired
                </div>
            )
        }

        return (
            <div>
                {formatTimeUnit(timeLeft.hours)}:{formatTimeUnit(timeLeft.minutes)}:{formatTimeUnit(timeLeft.seconds)}
            </div>
        )
    }

    useEffect(() => {
        calculatesubTotalAmount()
    }, [cartList])

    useEffect(() => {
        document.title = 'StoneSkill | AddToCart'
    })

    return (
        <>
            <main className="main">
                <div className="page-header breadcrumb-wrap">
                    <div className="container">
                        <div className="breadcrumb">
                            <Link to="/" rel="nofollow"><i className="fi-rs-home mr-5" />Home</Link>
                            <span /> Cart
                            <span />
                        </div>
                    </div>
                </div>
                <div className="container mb-80 mt-50">
                    <div className="row">
                        <div className="col-lg-8 mb-40">
                            <h1 className="heading-2 mb-10">Your Cart {cartList.length === 0 && ('Is Empty')}</h1>
                            <div className="d-flex justify-content-between">
                                <h6 className="text-body">There are <span className="text-brand">{cartList.length}</span> products in your cart</h6>
                                {cartList.length !== 0 && <h6 className="text-body"><span className="text-muted" style={{ cursor: "pointer" }} onClick={() => dispatch(clearCartItem())}>
                                    <i className="fi-rs-trash mr-5" />All Cart Clear </span></h6>}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-8">
                            {
                                cartList.length === 0 ? (
                                    ""
                                ) : (
                                    <div className="table-responsive shopping-summery">
                                        <table className="table table-wishlist">
                                            <thead>
                                                <tr className="main-heading">
                                                    <th scope="col" className='start pl-30' colSpan={2}>Product</th>
                                                    <th scope="col">Unit Price</th>
                                                    <th scope="col">Quantity</th>
                                                    <th scope="col">Subtotal</th>
                                                    <th scope="col" className="end">Remove</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    cartItems.length && cartItems.map((item) => (
                                                        <tr className="pt-30">
                                                            <td
                                                                className="image product-thumbnail pt-40 pl-30"
                                                            >
                                                                <Link to={`/ProductDetails/${formatSlug(item.product_title)}=${item.product_id}`}>
                                                                    <img
                                                                        src={item.product_image_url}
                                                                        alt="#"
                                                                    />
                                                                </Link>
                                                            </td>
                                                            <td
                                                                className="product-des product-name"
                                                            >
                                                                <h6
                                                                    className="mb-5"
                                                                >
                                                                    <Link
                                                                        className="product-name mb-10 text-heading"
                                                                        to={`/ProductDetails/${formatSlug(item.product_title)}=${item.product_id}`}
                                                                    >
                                                                        {item.product_title}
                                                                    </Link>
                                                                </h6>
                                                                <div className="product-rate-cover">
                                                                    <div className="product-rate d-inline-block">
                                                                        <div className="product-rating" style={{ width: '90%' }}>
                                                                        </div>
                                                                    </div>
                                                                    <span className="font-small ml-5 text-muted"> (4.0)</span>
                                                                </div>
                                                                <Countdown expiresAt={item.expiresAt} product_variant_id={item.product_variant_id} />
                                                            </td>
                                                            <td className="price" data-title="Price">
                                                                <h4 className="text-body">₹{item.product_variant_sale_price} </h4>
                                                            </td>
                                                            <td className="text-center detail-info" data-title="Stock">
                                                                <div className="detail-extralink mr-15">
                                                                    <div className="detail-qty border radius">
                                                                        <span className="qty-down"
                                                                        ><i className="fi-rs-angle-small-down"
                                                                            onClick={item.quantity > 1 ? () => dispatch(decreaseQuantity({ product_id: item?.product_id, product_variant_id: item?.product_variant_id })) : null}
                                                                            />
                                                                        </span>
                                                                        <input
                                                                            type="text"
                                                                            name="quantity"
                                                                            className="qty-val"
                                                                            value={item.quantity}
                                                                            min={1}
                                                                        />
                                                                        <span
                                                                            className="qty-up"
                                                                        >
                                                                            <i
                                                                                className="fi-rs-angle-small-up"
                                                                                onClick={() => dispatch(increaseQuantity({ product_id: item?.product_id, product_variant_id: item?.product_variant_id }))} style={{ cursor: 'pointer' }} /></span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="price" data-title="SubTotal">
                                                                <h4 className="text-brand"> ₹ {item.quantity * item.product_variant_sale_price} </h4>
                                                            </td>
                                                            <td
                                                                className="action text-center"
                                                                data-title="Remove"
                                                            >
                                                                <span
                                                                    className="text-body"
                                                                    style={{ cursor: "pointer" }}
                                                                    // onClick={() => handleRemoveCartItem(item)}
                                                                    onClick={() => dispatch(removeCartItem(item.product_variant_id))}>
                                                                    <i className="fi-rs-trash" />
                                                                </span>


                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                )
                            }
                            <div className="divider-2 mb-30" />
                            <div className="cart-action d-flex justify-content-between">
                                <Link to='/' className="btn mb-3"><i className="fi-rs-arrow-left mr-10" />Continue Shopping</Link>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="border p-md-4 cart-totals ml-30">
                                <div className="table-responsive">
                                    <table className="table no-border">
                                        <tbody>
                                            <tr className='d-flex d-sm-table-row py-2'>
                                                <td className="cart_total_label py-lg-3 px-lg-3">
                                                    <h6 className="text-muted mt-1">Subtotal : </h6>
                                                </td>
                                                <td className="cart_total_amount">
                                                    <h4 className="text-brand text-end">₹{subTotalAmount}</h4>
                                                </td>
                                            </tr>
                                            <tr className='d-flex d-sm-table-row py-2'>
                                                <td className="cart_total_label py-lg-3 px-lg-3">
                                                    <h6 className="text-muted mt-1">Shipping : </h6>
                                                </td>
                                                <td className="cart_total_amount">
                                                    <h5 className="text-heading text-end">Free </h5>
                                                </td>
                                            </tr>
                                            <tr className='d-flex d-sm-table-row py-2'>
                                                <td className="cart_total_label py-lg-3 px-lg-3">
                                                    <h6 className="text-muted mt-1">Estimate for : </h6>
                                                </td>
                                                <td className="cart_total_amount">
                                                    <h5 className="text-heading text-end">India </h5>
                                                </td>
                                            </tr>
                                            <tr className='d-flex d-sm-table-row py-2'>
                                                <td className="cart_total_label py-lg-3 px-lg-3">
                                                    <h6 className="text-muted mt-1">Total : </h6>
                                                </td>
                                                <td className="cart_total_amount">
                                                    <h4 className="text-brand text-end">₹{subTotalAmount}</h4>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                {
                                    cartList.length === 0
                                        ?
                                        <button disabled={cartList} className='btn mb-20 w-100'> Continue <i className="fi-rs-sign-out ml-15" /> </button>
                                        :
                                        <Link to={`/CheckOut`}
                                            className="btn mb-20 w-100"
                                        >
                                            Continue
                                            <i className="fi-rs-sign-out ml-15" />
                                        </Link>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default AddToCart;